(ns app.front.ui.results-tab-switcher
  "Row of joined buttons for choosing how a list of results is displayed."
  (:require ["@carbon/icons-react/es/grid/16" :default Grid16]
            ["@carbon/icons-react/es/list/16" :default List16]
            ["@carbon/icons-react/es/location/16" :default Location16]
            [app.front.ui :as ui]
            [clojure.string :as str]))

(def map-tab
  {:id   :dashboard-search/map-view
   :icon Location16})

(def list-tab
  {:id   :dashboard-search/list-view
   :icon List16})

(def grid-tab
  {:id   :dashboard-search/grid-view
   :icon Grid16})

(def default-tabs
  [map-tab list-tab grid-tab])

(defn- tab-button [{:keys [tr tab selected? first? last? on-select]}]
  (let [{:keys [id icon]} tab]
    [ui/button
     {:kind         :ghost
      :aria-pressed selected?
      :data-cy      (str "results-tab-" (name id))
      :class-name   (str/join " " ["flex items-center gap-2 rounded-none border border-solid border-ui-gray"
                                   "px-4 py-3 min-h-0 font-semibold normal-case"
                                   (when-not first? "-ml-px")
                                   (when first? "rounded-l")
                                   (when last? "rounded-r")
                                   "hover:bg-ui-violet-100 hover:text-ui-white"
                                   (if selected?
                                     "bg-ui-night-sky-100 text-ui-white"
                                     "bg-ui-light-gray text-ui-night-sky-100")])
      :on-click     #(on-select id)}
     [:> icon]
     (tr [id])]))

(defn results-tab-switcher
  "Buttons for selecting the display mode of a list of results, e.g. map, list or grid.

  `tabs`         - display modes as `{:id :icon}` maps, the id doubling as the translation key
  `selected-tab` - id of the currently selected tab
  `on-select`    - called with the id of the tab that was clicked
  `tr`           - translation fn"
  [{:keys [tabs selected-tab on-select tr]}]
  (let [tabs           (vec tabs)
        last-tab-index (dec (count tabs))]
    (into [:div.flex]
          (map-indexed (fn [idx tab]
                         [tab-button {:tr        tr
                                      :tab       tab
                                      :selected? (= selected-tab (:id tab))
                                      :first?    (zero? idx)
                                      :last?     (= idx last-tab-index)
                                      :on-select on-select}]))
          tabs)))
